export default {
  teams: {
    header: 'Teams',
    filters: {
      header: 'Filter',
      location: 'Location',
      jobCategories: 'Job Categories',
      nameSearch: 'Search Team Name',
      searchLabel: 'Search',
      searchButton: 'Search',
      clearAll: 'Clear All Filters',
      common: {
        all: 'All',
        select: 'Select...'
      }
    },
    manageTeamsModal: {
      manageTeamModalTeamsText: 'Teams',
      manageTeamModalAdd: 'Add',
      manageTeamModalRemove: 'Remove',
      manageTeamModalTitle: 'Manage Teams',
      manageTeamModalSubTitle: 'Add or remove Wonoloer to or from the selected teams',
      manageTeamModalDone: 'Done',
      manageTeamModalCreateNew: 'Create New Team',
      manageTeamModalCreateNewLabel: 'Name',
      manageTeamModalCreate: 'Create',
      manageTeamModalEmptyHeader: 'Create a new team!'
    },
    deleteTeamModal: {
      title: 'Delete Team',
      content: 'Are you sure you want to delete the %teamName% team?',
      successMessage: 'Team deleted',
    },
    list: {
      header: 'Teams List',
      clearSort: 'Reset',
      noResultsHeader: 'No Teams Found',
      noResultsBody: 'Empty',
      orderOptions: {
        lastUpdateAsc: 'Most Recent',
        lastUpdateDesc: 'Oldest'
      }
    },
    duplicateTeamNameError: 'Sorry that name is already in use',
  },
  wonoloerList: {
    header: 'Workforce',
    wonoloerListNameHeader: 'Wonoloer Name',
    wonoloerListLastJobHeader: 'Last Job Completed',
    wonoloerListBlockedHeader: 'Blocked By',
    wonoloerListNotAvailable: 'Wonoloer list is not available.',
    noResultsHeader: 'No Workers Found',
    noResultsBody: 'Empty',
    filters: {
      nameSeachPlaceholder: 'Search Wonoloer name',
      nameSearchLabel: 'Search',
      wonoloerStatusLabel: 'Wonoloer Status',
      wonoloerStatusPlaceholder: 'All',
      wonoloerFilterClearAll: 'Clear All Filters',
      wonoloerStatusOptions: {
        allText: 'All',
        activeText: 'Active',
        bannedText: 'Banned'
      }
    }
  },
  profile: {
    sidebar: {
      criminalBackgroundText: 'Criminal Background Check passed',
      generalLiabilityText: 'General Liability Insurance',
      occupationalAccidentText: 'Occupational Accident Insurance (for 1099)',
      workerCompensationInsuranceText: 'Workers Compensation Insurance (for W-2)',
      contactInfoTableHeader: 'Contact Info'
    },
    header: {
      hireButton: 'Report Hire',
      isHiredButton: 'Hired',
      date: 'Wonoloing Since ',
      wonoloerRating: 'Overall Rating',
      customerRating: '\'s Rating',
      jobsCompleted: 'Total Completed Jobs',
      jobsFor: 'Jobs for',
      jobsForYou: 'Jobs for You',
      preferredJobsCount: 'Preferred Jobs'
    },
    body: {
      experienceTableHeader: 'Experience',
      experienceTableJobsSingle: 'job',
      experienceTableJobsPlural: 'jobs',
      experienceTableCompanySingle: 'company',
      experienceTableCompanyPlural: 'companies',
      experienceTableAvatarAlt: 'experience',
      badgeTableHeader: 'Badges',
      badgeTableAvatarAlt: 'badge'
    },
    jobsForYouTable: {
      header: 'Jobs For You',
      when: 'When',
      where: 'Where',
      status: 'Status',
      rating: 'Rating',
      details: 'Details'
    }
  },
  modals: {
    reportHire: {
      title: 'Hire %workerName%',
      cancel: 'Cancel',
      confirm: 'Confirm',
      sentencePart1: 'I am interested in hiring ',
      sentencePart2: ' to work for %companyName% ',
      sentencePart3: 'outside of the Wonolo platform.',
      datePlaceholder: 'Proposed Start Date (optional)',
      notesPlaceholder: 'Notes (optional)',
      footer: {
        sentence1: 'You will receive an email confirmation for the Direct Hire Fee in the next 30 days.',
        sentence2: 'Standard rates apply for ad-hoc customers.'
      }
    }
  }
};
